import { ref, watch, onMounted } from 'vue';
import { usePage, router } from '@inertiajs/vue3';

export default function useTheme() {
    const darkMode = ref(false);
    const page = usePage();

    const toggleDarkMode = () => {
        darkMode.value = !darkMode.value;
        applyTheme();
        saveThemePreference();
    };

    const applyTheme = () => {
        // Apply theme using Bootstrap's data-bs-theme attribute
        document.documentElement.setAttribute('data-bs-theme', darkMode.value ? 'dark' : 'light');
    };

    const saveThemePreference = () => {
        // Save to localStorage for all users
        localStorage.setItem('theme', darkMode.value ? 'dark' : 'light');
        
        // If user is authenticated, save to database
        if (page.props.value && page.props.value.auth && page.props.value.auth.user) {
            router.post(route('user.preferences.theme'), {
                theme: darkMode.value ? 'dark' : 'light'
            }, {
                preserveState: true,
                preserveScroll: true,
            });
        }
    };
    
    onMounted(() => {
        // Check for saved theme in user preferences or localStorage
        if (page.props.value && 
            page.props.value.auth && 
            page.props.value.auth.user && 
            page.props.value.auth.user.theme) {
            darkMode.value = page.props.value.auth.user.theme === 'dark';
        } else {
            const savedTheme = localStorage.getItem('theme');
            if (savedTheme) {
                darkMode.value = savedTheme === 'dark';
            } else {
                // Fallback to light mode if nothing is set
                darkMode.value = false;
            }
        }
        
        applyTheme();
    });

    return {
        darkMode,
        toggleDarkMode
    };
}
